import Grid from '@/global/components/ui/Grid'
import { Empresa } from '@/service/api'
import { TipoDescontoDSR } from '@acme/core'
import {
    FormField,
    FormFieldCheckbox,
    FormFieldSelect,
} from 'global/components/Form'
import IconeAjuda from 'global/components/IconeAjuda'
import { useEffect } from 'react'
import { useFormContext } from 'react-hook-form'

export default function DescontoDSR() {
    const { watch, setValue } = useFormContext<Empresa>()
    const tipoDescontoDSR = watch('tipoDescontoDSR')

    useEffect(() => {
        if (tipoDescontoDSR != TipoDescontoDSR.ATRASO)
            setValue('atrasoDescontoDSR', '')
    }, [tipoDescontoDSR])

    return (
        <section id="dsr" className="w-full">
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <FormFieldSelect
                        label="Tipo de desconto"
                        name="tipoDescontoDSR"
                        required
                        options={[
                            {
                                label: 'Não descontar',
                                value: TipoDescontoDSR.NAO_DESCONTAR,
                            },
                            {
                                label: 'Descontar em falta integral',
                                value: TipoDescontoDSR.FALTA_INTEGRAL,
                            },
                            {
                                label: 'Descontar em turno faltado',
                                value: TipoDescontoDSR.TURNO,
                            },
                            {
                                label: 'Descontar em atraso',
                                value: TipoDescontoDSR.ATRASO,
                            },
                        ]}
                        endAdornment={
                            <IconeAjuda className="mr-4">
                                <p>DSR - Descanso semanal remunerado de 24h.</p>
                                <br />
                                <p>
                                    Para ter direito ao pagamento do DSR, o
                                    trabalhador deve ter frequência e
                                    pontualidade na semana. Faltas ou atrasos
                                    podem gerar desconto.
                                </p>
                                <br />
                                <p>
                                    Para empresas com banco de horas, o DSR só é
                                    descontado em faltas injustificadas.
                                </p>
                            </IconeAjuda>
                        }
                    />
                </Grid>
                {tipoDescontoDSR == TipoDescontoDSR.ATRASO && (
                    <Grid item xs={3}>
                        <FormField
                            name="atrasoDescontoDSR"
                            label="Tempo de atraso"
                            required
                            InputLabelProps={{ shrink: true }}
                            InputProps={{
                                endAdornment: (
                                    <IconeAjuda>
                                        Esse campo define o tempo de atraso para
                                        desconto de DSR. Exemplo: se o valor for
                                        15 minutos, o sistema irá descontar DSR
                                        se o funcionário atrasar mais de 15
                                        minutos.
                                    </IconeAjuda>
                                ),
                            }}
                            placeholder="HH:mm"
                            options={{
                                blocks: [2, 2],
                                delimiters: [':'],
                                numericOnly: true,
                            }}
                        />
                    </Grid>
                )}
                {tipoDescontoDSR == TipoDescontoDSR.ATRASO && (
                    <Grid item xs={4}>
                        <FormFieldSelect
                            name="periodoDescontoDSR"
                            label=""
                            options={[
                                { label: 'No dia', value: 'DIA' },
                                { label: 'Na semana', value: 'SEMANA' },
                            ]}
                            endAdornment={
                                <IconeAjuda className="mr-4">
                                    Esse campo define se o DSR será descontado
                                    quando ocorrer o atraso no dia ou se a soma
                                    dos atrasos na semana será considerada para
                                    o desconto de DSR.
                                </IconeAjuda>
                            }
                        />
                    </Grid>
                )}
            </Grid>
            <Grid container spacing={1} className="mt-4">
                <Grid item xs={12} sm={7}>
                    <FormFieldCheckbox
                        name="faltaJustificadaDescontaDSR"
                        label="Descontar DSR em faltas justificadas"
                    />
                </Grid>
                <Grid
                    item
                    xs={12}
                    sm={5}
                    className="flex flex-row items-center"
                >
                    <FormFieldCheckbox
                        name="dsrDescontaFeriado"
                        label="Descontar DSR do feriado"
                    />
                    <IconeAjuda>
                        Se o campo estiver marcado, o sistema irá descontar DSR
                        do feriado quando o funcionário faltar na mesma semana
                        do feriado.
                    </IconeAjuda>
                </Grid>
                <Grid item xs={7} className="flex flex-row items-center">
                    <FormFieldCheckbox
                        name="dsrExibeHoras"
                        label="Exibir desconto em horas"
                    />
                    <IconeAjuda>
                        Se o campo estiver marcado, o sistema irá exibir o
                        desconto de DSR em horas nos relatórios e na tela de
                        digitação. Caso contrário, o sistema irá exibir o
                        desconto em dias.
                    </IconeAjuda>
                </Grid>
            </Grid>
        </section>
    )
}
